<template #default>
  <div class="page-view">
    <a-card class="page-filter" :bordered="false">
      <a-form layout="inline" @submit.prevent="onSearch">
        <a-form-item label="Account">
          <a-input
            v-model:value="accountCode"
            placeholder="Enter code..."
            @pressEnter="onSearch"
          />
        </a-form-item>
        <a-form-item label="Fund">
          <a-select
            v-model:value="selectedFundCode"
            style="width: 260px"
            allow-clear
            show-search
            placeholder="All"
            :filter-option="filterOption"
          >
            <a-select-option
              v-for="item in fundList"
              :key="item.fundCode"
              :value="item.fundCode"
            >
              {{ item.fundCode }} - {{ item.fundDesc }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Custodian">
          <a-select
            v-model:value="selectedCustodianCode"
            placeholder="All"
            style="width: 200px"
            allow-clear
            show-search
            :filter-option="filterOption"
          >
            <a-select-option
              v-for="item in custodianList"
              :key="item.custodianCode"
              :value="item.custodianCode"
            >
              {{ item.custodianCode }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="AccountType">
          <a-select
            v-model:value="selectedAccountType"
            placeholder="All"
            style="width: 160px"
            allow-clear
            show-search
            :filter-option="filterOption"
          >
            <a-select-option
              v-for="item in accountTypeList"
              :key="item.code"
              :value="item.code"
            >
              {{ item.desc }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Status">
          <a-select
            v-model:value="active"
            style="width: 120px"
            allow-clear
            placeholder="All"
          >
            <a-select-option value="true">Active</a-select-option>
            <a-select-option value="false">InActive</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <div class="page-actions">
            <a-button type="primary" @click="onSearch" :loading="loading"
              >Search</a-button
            >
            <a-button v-if="isAdminOrItRole" @click="showAddModal">
              Add
            </a-button>
          </div>
        </a-form-item>
      </a-form>
    </a-card>

    <div class="page-grid page-grid--h360">
      <AgGridVue
        style="width: 100%; height: 100%"
        :theme="themeBalham"
        :loading="loading"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="rowData"
        :gridOptions="gridOptions"
        :getRowId="getRowId"
      />
    </div>

    <!-- Add/Edit Account Modal -->
    <a-modal
      class="page-modal"
      v-model:visible="addModalVisible"
      :title="isEdit ? 'Edit Custodian Account' : 'Add Custodian Account'"
      @ok="isEdit ? handleEditCustodianAccount() : handleAddCustodianAccount()"
      @cancel="handleAddCancel"
      :confirmLoading="addLoading"
      destroyOnClose
    >
      <a-form
        :model="addForm"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 16 }"
        layout="horizontal"
      >
        <a-form-item label="Account Code" required>
          <a-input
            v-model:value="addForm.accountCode"
            placeholder="Enter account code"
            :disabled="isEdit"
            @input="onAccountCodeInput"
          />
        </a-form-item>
        <a-form-item label="Account Desc">
          <a-input
            v-model:value="addForm.accountDesc"
            placeholder="Enter account description"
          />
        </a-form-item>
        <a-form-item label="Fund" required>
          <a-select
            v-if="isEdit"
            v-model:value="addForm.fundId"
            placeholder="Select fund"
            style="width: 100%"
            show-search
            :filter-option="filterOption"
            :disabled="isEdit"
          >
            <a-select-option
              v-for="item in allFundList"
              :key="item.fundCode"
              :value="item.fundId"
            >
              {{ item.fundCode }} - {{ item.fundDesc }}
            </a-select-option>
          </a-select>
          <a-select
            v-else
            v-model:value="addForm.fundId"
            placeholder="Select fund"
            style="width: 100%"
            show-search
            :filter-option="filterOption"
            :disabled="isEdit"
          >
            <a-select-option
              v-for="item in fundList"
              :key="item.fundCode"
              :value="item.fundId"
            >
              {{ item.fundCode }} - {{ item.fundDesc }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Custodian" required>
          <a-select
            v-model:value="addForm.custodianId"
            placeholder="Select custodian"
            style="width: 100%"
            show-search
            :filter-option="filterOption"
            :disabled="isEdit"
          >
            <a-select-option
              v-for="item in custodianList"
              :key="item.custodianCode"
              :value="item.custodianId"
            >
              {{ item.custodianCode }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="AccountType" required>
          <a-select
            v-model:value="addForm.accountType"
            placeholder="Select type"
            :show-search="true"
            :filter-option="filterOption"
          >
            <a-select-option
              v-for="item in accountTypeList"
              :key="item.desc"
              :value="item.code"
            >
              {{ item.desc }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="PnlEngineType">
          <a-select
            v-model:value="addForm.pnlEngineType"
            placeholder="Select PnlEngineType"
            :show-search="true"
            :filter-option="filterOption"
          >
            <a-select-option
              v-for="item in pnlEngineTypeList"
              :key="item.desc"
              :value="item.code"
            >
              {{ item.desc }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="IsActive">
          <a-select
            v-model:value="addForm.isActive"
            placeholder="Select status"
            style="width: 120px"
          >
            <a-select-option value="true">Active</a-select-option>
            <a-select-option value="false">InActive</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, defineExpose } from 'vue'
import { useStore } from 'vuex'
import { themeBalham } from 'ag-grid-community'

import { message } from 'ant-design-vue'
// import dayjs from 'dayjs'
import custodianAccountView_ColumnDefs from '@/views/reference/custodianaccount/CustodianAccountView_ColumnDefs'
import AgEditCellRenderer from '@/components/AgEditCellRenderer.vue'
import custodianAccount from '@/api/custodianAccount'
import organization from '@/api/organization'

const store = useStore()

const defaultColDef = {
  filter: true,
  sortable: true,
  resizable: true,
  enableCellChangeFlash: true,
}

defineExpose({
  AgEditCellRenderer,
})

const selectedFundCode = ref(undefined)
const selectedCustodianCode = ref(undefined)
const selectedAccountType = ref(undefined)
// Change active to string type and default to undefined (for "All")
const active = ref(undefined)
const accountCode = ref('')
const loading = ref(false)
const rowData = ref([])
const gridApi = ref(null)

const getErrorMessage = (error, fallback) =>
  error?.response?.data?.message || fallback

const gridOptions = ref({
  suppressScrollOnNewData: true,

  onGridReady: (params) => {
    gridApi.value = params.api
  },
})
const getRowId = (params) => {
  return String(params?.data?.accountId ?? '')
}

const isAdminOrItRole = computed(() => {
  const roles = store.getters['auth/getRoleList'] || []
  const roleNames = [...roles].map((r) => r.name)
  return roleNames.includes('SRM_Admin') || roleNames.includes('SRM_IT')
})

const custodianList = ref([])

const accountTypeList = computed(() => [
  {
    code: 'NONE',
    desc: 'NONE',
  },
  {
    code: 'ADMIN',
    desc: 'ADMIN',
  },
  {
    code: 'CASH',
    desc: 'CASH',
  },
  {
    code: 'CUST',
    desc: 'CUST',
  },
  {
    code: 'FNO',
    desc: 'FNO',
  },
  {
    code: 'ISDA',
    desc: 'ISDA',
  },
  {
    code: 'MARG',
    desc: 'MARG',
  },
  {
    code: 'OTC_BILAT',
    desc: 'OTC_BILAT',
  },
  {
    code: 'OTC_PB',
    desc: 'OTC_PB',
  },
  {
    code: 'PB',
    desc: 'PB',
  },
  {
    code: 'XTFO_CASH',
    desc: 'XTFO_CASH',
  },
])

const pnlEngineTypeList = computed(() => [
  {
    code: '',
    desc: 'None',
  },
  {
    code: 'FourSides',
    desc: 'FourSides',
  },
])

const addModalVisible = ref(false)
const addLoading = ref(false)

const createEmptyForm = () => ({
  accountCode: '',
  accountDesc: '',
  custodianId: null,
  fundId: null,
  accountType: 'CUST',
  pnlEngineType: 'None',
  isActive: 'true',
})

const addForm = ref(createEmptyForm())
const isEdit = ref(false)

const fundList = computed(() => {
  const funds = store.getters['reference/getFundList'] || []
  return [...funds]
    .filter((f) => f.isActive && f.isReal)
    .sort((a, b) => a.fundCode.localeCompare(b.fundCode))
})

const allFundList = computed(() => {
  const funds = store.getters['reference/getFundList'] || []
  return [...funds].sort((a, b) => a.fundCode.localeCompare(b.fundCode))
})

const filterOption = (input, option) => {
  return option.key.toLowerCase().indexOf(input.toLowerCase()) >= 0
}

const getActiveValue = () => {
  if (active.value === 'true') return true
  if (active.value === 'false') return false
  return undefined
}

const onSearch = async () => {
  loading.value = true
  try {
    const qry = {
      accountCode: accountCode.value.trim(),
      fundCode: selectedFundCode.value,
      custodianCode: selectedCustodianCode.value,
      accountType: selectedAccountType.value,
      isActive: getActiveValue(),
    }
    const resp = await custodianAccount.getCustodianAccounts(qry)
    const data = resp.data
    rowData.value = Array.isArray(data) ? data : []
    if (rowData.value.length === 0) {
      message.info('No data found.')
    }
  } catch (e) {
    message.error(getErrorMessage(e, 'Query failed'))
  } finally {
    loading.value = false
  }
}

const showAddModal = () => {
  isEdit.value = false
  addForm.value = createEmptyForm()
  addModalVisible.value = true
}

const showEditModal = (event) => {
  const data = event?.data || event
  isEdit.value = true
  addForm.value = {
    ...data,
    isActive: String(data?.isActive ?? true),
  }
  addModalVisible.value = true
}

const handleAddCancel = () => {
  addModalVisible.value = false
}

const validateForm = () => {
  if (!addForm.value.accountCode || !addForm.value.fundId) {
    message.warning('Please fill all required fields.')
    return false
  }
  if (!addForm.value.custodianId || !addForm.value.accountType) {
    message.warning('Please fill all required fields.')
    return false
  }
  return true
}

const handleAddCustodianAccount = async () => {
  if (!validateForm()) return
  addLoading.value = true
  try {
    const payload = {
      ...addForm.value,
      isActive: addForm.value.isActive === 'true',
    }
    const fund = fundList.value.find((f) => f.fundId === payload.fundId)
    if (fund) {
      payload.fundCode = fund.fundCode
    }
    const custodian = custodianList.value.find(
      (c) => c.custodianId === payload.custodianId
    )
    if (custodian) {
      payload.custodianCode = custodian.custodianCode
    }
    await custodianAccount.createCustodianAccount(payload)
    message.success('Add success')
    addModalVisible.value = false
    onSearch()
  } catch (e) {
    message.error(getErrorMessage(e, 'Add failed'))
  } finally {
    addLoading.value = false
  }
}

/* const handleFundChanged = async (value) => {
  selectedCustodianCode.value = null
  const fund = fundList.value.find((f) => f.fundCode === value)
  const custodianResp = await organization.getOrganizations({
    organizationCode: null,
    organizationTypeCode: 'CUSTODIAN',
    statusCode: 'A',
    fundId: fund ? fund.fundId : null,
  })
  custodianList.value =
    custodianResp.data.map((r) => ({
      custodianId: r.organizationId,
      custodianCode: r.organizationCode,
    })) || []
} */

const handleEditCustodianAccount = async () => {
  if (!validateForm()) return
  addLoading.value = true
  try {
    const payload = {
      ...addForm.value,
      isActive: addForm.value.isActive === 'true',
    }
    payload.fundCode = null
    payload.custodianCode = null
    await custodianAccount.updateCustodianAccount(payload)

    const rowIndex = rowData.value.findIndex(
      (r) => r.accountId === addForm.value.accountId
    )
    if (rowIndex !== -1) {
      rowData.value[rowIndex] = {
        ...addForm.value,
        isActive: payload.isActive,
      }
    }
    message.success('Edit success')
    addModalVisible.value = false
  } catch (e) {
    message.error(getErrorMessage(e, 'Edit failed'))
  } finally {
    addLoading.value = false
  }
}

const columnDefs = custodianAccountView_ColumnDefs.map((col) => {
  if (col.field === 'edit') {
    return {
      ...col,
      cellRendererParams: {
        showEditModal: (data) => showEditModal(data),
      },
    }
  }
  return col
})

const onAccountCodeInput = (event) => {
  const value = event?.target?.value || ''
  addForm.value.accountCode = value.toUpperCase()
}

onMounted(async () => {
  try {
    const custodianResp = await organization.getOrganizations({
      organizationCode: null,
      organizationTypeCode: 'CUSTODIAN',
      statusCode: 'A',
    })
    custodianList.value =
      custodianResp.data.map((r) => ({
        custodianId: r.organizationId,
        custodianCode: r.organizationCode,
      })) || []
  } catch (e) {
    message.error(getErrorMessage(e, 'Failed to fetch reference lists'))
  }
})
</script>
